export * from './news-manager.service';
export * from './table-config.service';